import { configureStore } from '@reduxjs/toolkit';
import { reducers } from './slices';
import { setupListeners } from '@reduxjs/toolkit/query';
import { ENV } from '../constants';
import lawyerMessageMiddleware from './middleware/lawyer-messages';

const store = configureStore({
  reducer: {
    ...reducers,
    // [websocketApi.reducerPath]: websocketApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(lawyerMessageMiddleware.middleware),
  devTools: ENV.NODE_ENV !== 'production',
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
setupListeners(store.dispatch);
